import { render, staticRenderFns } from "./ambience.vue?vue&type=template&id=57ff1019"
import script from "./ambience.vue?vue&type=script&lang=js"
export * from "./ambience.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports